import Immutable from 'immutable';
import validator from 'validator';

// Indicates which backend the ARC was fetched from. ARCs fetched from the
// legacy admin API are 'v3'; ARCs fetched from the V4 platform (lib-ui-core)
// are 'v4'. The model is the same shape either way — v4-specific concepts
// (endpoints, link requirements) live in `v4Data` until lib-ui-core catches
// up with the fields the V3 UI already exposes (proms, salesItem, etc.).
export const ARCSource = {
	V3: 'v3',
	V4: 'v4',
};

const ARCModel = Immutable.Record({
	id: 0,
	key: '',
	name: '',
	color: '',
	label: '',
	email: '', //only used for creation form
	proms: [],
	whitelistNumbers: [],
	emergencyNumbers: [],
	variables: [],
	salesItem: null,

	accounts: 0,
	devices: 0,

	// V4-only: when true only the ARC may close its alarms (mirrored per-alarm as
	// `arc_forward.exclusive_closing`).
	exclusiveClosing: false,

	source: ARCSource.V3,
	v4Data: null,
	// Local draft of V4 endpoints while editing. `v4Data.endpoints` remains the
	// server baseline so the save saga can diff and only push actual changes.
	v4Endpoints: null,
	// Merged display record (V3 ARC + its same-key V4 twin); set by dedupeArcsByKey.
	hasV3Twin: false,
});

export default class ARC extends ARCModel {
	id: number;
	key: string;
	name: string;
	color: string;
	label: string;
	email: string;
	proms: any[];
	whitelistNumbers: string[];
	emergencyNumbers: string[];
	variables: any[];
	salesItem: ?string;
	
	accounts: number;
	devices: number;
	exclusiveClosing: boolean;
	source: string;
	v4Data: ?any;
	v4Endpoints: ?any[];
	hasV3Twin: boolean;

	get isV4(): boolean {
		return this.source === ARCSource.V4;
	}
	get isV3(): boolean {
		return this.source === ARCSource.V3;
	}

	forKey(key) : boolean {
		if(!key) return false;
		return this.key.trim().lc() === key.split(':')[0].trim().lc();
	}
	
	get hasProms() {
		return !!this.proms?.length;
	}
	get isValid() {
		if(this.name?.length < 3) return false;
		if(!this.color) return false;
		if(!this.label) return false;
		if(this.isV4) {
			// V4 requires a key (2–50 chars) on creation. Existing V4 ARCs keep
			// their server key (held in v4Data) and don't re-edit it here.
			if(!this.id) {
				const key = (this.key || '').trim();
				if(key.length < 2 || key.length > 50) return false;
			}
		} else {
			// V3-only constraints: key, creation email, and sales item. V4 uses
			// platform-wide billing and has no email/salesItem concept.
			if(this.key?.length < 3) return false;
			if(!this.id && !validator.isEmail(this.email)) return false;
			if(this.salesItem !== null && this.salesItem?.length < 10) return false;
		}
		return true;
	}
	get filterString() {
		return [
			this.key,
			this.name,
			this.label
		].join('').lc();
	}
	
}
